import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchScreenchatPass, screenchatKeys } from "../../api/screenchat";
import { useAuth } from "../../context/AuthContext";

/**
 * 🧩 스크린챗(운영자의 기획 에이전트)을 app.phoneboard.kr 화면 안에 붙인다 — App 루트에 한 번. 진본 docs/ops/screenchat-embed.md
 *
 * 패키지를 불러오는 건 **스크린챗 «서비스 계정으로 들어오기» 명단에 있는 사람**뿐이다 — 서버가 명단을 확인해 통행증을 주면 💬 를 띄우고,
 * 패널은 그 통행증으로 로그인 화면 없이 들어간다(핸드폰 로그인 한 번이 전부). 명단 밖이면 통행증이 null 이고, 그 브라우저에서는
 * 패키지를 **불러오지도 않는다**. 명단은 운영자가 스크린챗에서 고른다(처음엔 비어 있다 — 아무에게도 안 보인다).
 *
 * 대화 화면은 screen-chat.com 의 창(iframe)이라 스크린챗 로그인 열쇠는 핸드폰으로 오지 않는다. 패키지 꾸러미는 `vendor/`.
 */
export default function ScreenChatMount() {
  const { user } = useAuth();
  const userId = user?.id ?? null;
  // 로그인한 사람마다 한 번 묻는다 — 명단을 바꾼 뒤엔 새로고침하면 다시 묻는다.
  const { data: pass } = useQuery({
    queryKey: screenchatKeys.pass(userId ?? "-"),
    queryFn: fetchScreenchatPass,
    enabled: !!userId,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  useEffect(() => {
    if (!pass) return;
    let alive = true;
    let unmount: (() => void) | null = null;
    import("@screenchat/embed")
      .then(({ mountScreenChat }) => {
        if (!alive) return;
        unmount = mountScreenChat({ alwaysShow: true, getPass: fetchScreenchatPass }).unmount;
      })
      .catch((error: unknown) => {
        // 덤이다 — 스크린챗을 못 붙여도 핸드폰 화면은 그대로 돈다. 원인만 남긴다.
        console.warn("[screenchat] 스크린챗을 붙이지 못했다", error);
      });
    // 로그아웃하거나 다른 사람으로 바뀌면(통행증이 바뀌거나 사라지면) 떼어 낸다.
    return () => {
      alive = false;
      unmount?.();
    };
  }, [pass]);

  return null;
}
